export const dark = {
  key: 'dark',
  primaryTextColor: '#FFFFFF',
  secondaryTextColor: '#C7CBD6',
  tertiaryTextColor: '#8A90A2',
  background: '#0A0E27',
  backgroundElevated: '#121628',
  surface: 'rgba(255, 255, 255, 0.04)',
  surfaceHover: 'rgba(255, 255, 255, 0.07)',
  border: 'rgba(255, 255, 255, 0.10)',
  borderStrong: 'rgba(255, 255, 255, 0.18)',
  accent: '#3B82F6',
  cta: '#2563EB',
  ctaHover: '#1D4ED8',
  shadowColor: 'rgba(0, 0, 0, 0.5)',
  glow: 'rgba(37, 99, 235, 0.35)',
};

export const light = {
  key: 'light',
  primaryTextColor: '#0F172A',
  secondaryTextColor: '#334155',
  tertiaryTextColor: '#64748B',
  background: '#F8FAFC',
  backgroundElevated: '#FFFFFF',
  surface: 'rgba(15, 23, 42, 0.03)',
  surfaceHover: 'rgba(15, 23, 42, 0.06)',
  border: 'rgba(15, 23, 42, 0.12)',
  borderStrong: 'rgba(15, 23, 42, 0.20)',
  accent: '#2563EB',
  cta: '#2563EB',
  ctaHover: '#1D4ED8',
  shadowColor: 'rgba(15, 23, 42, 0.12)',
  glow: 'rgba(37, 99, 235, 0.25)',
};
